// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
:host {
  position: relative;
  display: inline-block;
}

.bold-label {
  font-weight: bolder;
}

.trigger-icon {
  font-size: 16px;
  height: 16px;
  width: 16px;
  vertical-align: text-bottom;
  margin-left: 2px;
}

.compact-trigger {
  min-width: 0;
  padding: 0;
  line-height: normal;
  background: none;
  color: #0066b2;
  font-family: "GothamBold", Arial, sans-serif;
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 0;
}
.compact-trigger:hover {
  color: #0b2d71;
  background: none;
}
.compact-trigger .trigger-icon {
  font-size: 18px;
  height: 18px;
  width: 18px;
  margin-left: 4px;
}

.share-link-popover {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px;
  background: white;
  border-radius: 4px;
  border: 1px solid #ededee;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.16);
}
.share-link-popover--open-right {
  right: auto;
  left: 0;
}

.share-link-input {
  field-sizing: content;
  min-width: 300px;
  max-width: calc(100vw - 80px);
  max-width: calc(100dvw - 80px);
  height: 34px;
  padding: 0 10px;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  background: #e4f4fa;
  color: #707070;
  font-family: "Gotham", Arial, sans-serif;
  font-size: 17px;
}
.share-link-input:focus {
  outline: 1px solid #0066b2;
}

.share-link-spinner {
  margin: 3px 8px;
}

.copy-button {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: none;
  color: #0066b2;
  cursor: pointer;
}
.copy-button:hover {
  background-color: #e4f4fa;
}
.copy-button mat-icon {
  font-size: 20px;
  height: 20px;
  width: 20px;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
